const SafetyIconSlingLifting = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M26.5204 19.0273H10.1997C9.87626 19.0273 9.61426 19.2908 9.61426 19.6128C9.61426 19.9363 9.87626 20.1983 10.1997 20.1983H26.5204C26.8438 20.1983 27.1059 19.9363 27.1059 19.6128C27.1059 19.2908 26.8438 19.0273 26.5204 19.0273Z"
      fill="#171717"
    />
    <path
      d="M28.0029 16.7383H20.9141V14.5178C20.9126 13.6615 20.2188 12.9692 19.364 12.9678H18.7668V8.58549C18.7668 8.26201 18.5048 8 18.1813 8C17.8578 8 17.5958 8.26201 17.5958 8.58549V12.9678H17.0718C16.2155 12.9692 15.5218 13.6616 15.5203 14.5178V16.7368H8.71401V16.7383C7.76846 16.7383 7.00146 17.5068 7 18.4538V26.2845C7.00146 27.2301 7.76846 27.9985 8.71401 28H28.0031C28.9501 27.9985 29.7171 27.2301 29.7186 26.2845V18.4538C29.7171 17.5068 28.9499 16.7383 28.0029 16.7383ZM16.6911 14.5178C16.6911 14.3085 16.8609 14.1387 17.0702 14.1387H17.5956V15.0902C17.5956 15.4136 17.8577 15.6757 18.1811 15.6757C18.5046 15.6757 18.7666 15.4136 18.7666 15.0902V14.1387H19.3638C19.5731 14.1387 19.7429 14.3085 19.7429 14.5178V16.7368L16.6911 16.7383V14.5178ZM28.5474 26.2861C28.5459 26.5861 28.3029 26.8306 28.0029 26.8306H8.71678C8.41672 26.8306 8.17229 26.5861 8.17229 26.2861V18.4553C8.17229 18.1553 8.41673 17.9108 8.71678 17.9108H28.0029C28.3029 17.9108 28.5474 18.1553 28.5474 18.4553V26.2861Z"
      fill="#171717"
    />
    <path
      d="M26.5204 21.748H10.1997C9.87626 21.748 9.61426 22.0101 9.61426 22.3335C9.61426 22.657 9.87626 22.919 10.1997 22.919H26.5204C26.8438 22.919 27.1059 22.657 27.1059 22.3335C27.1059 22.0101 26.8438 21.748 26.5204 21.748Z"
      fill="#171717"
    />
    <path
      d="M26.5204 24.3242H10.1997C9.87626 24.3242 9.61426 24.5862 9.61426 24.9097C9.61426 25.2332 9.87626 25.4952 10.1997 25.4952H26.5204C26.8438 25.4952 27.1059 25.2332 27.1059 24.9097C27.1059 24.5862 26.8438 24.3242 26.5204 24.3242Z"
      fill="#171717"
    />
  </svg>
)

export default SafetyIconSlingLifting
